var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1147_28516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.333 4.66699H8.66634V6.00033H11.333C12.433 6.00033 13.333 6.90033 13.333 8.00033C13.333 9.10033 12.433 10.0003 11.333 10.0003H8.66634V11.3337H11.333C13.173 11.3337 14.6663 9.84033 14.6663 8.00033C14.6663 6.16033 13.173 4.66699 11.333 4.66699ZM7.33301 10.0003H4.66634C3.56634 10.0003 2.66634 9.10033 2.66634 8.00033C2.66634 6.90033 3.56634 6.00033 4.66634 6.00033H7.33301V4.66699H4.66634C2.82634 4.66699 1.33301 6.16033 1.33301 8.00033C1.33301 9.84033 2.82634 11.3337 4.66634 11.3337H7.33301V10.0003ZM5.33301 7.33366H10.6663V8.66699H5.33301V7.33366Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1147_28516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLink);
export default __webpack_public_path__ + "static/media/buttonLink.1cfe4e931e3b37ab918c83b833d1ab95.svg";
export { ForwardRef as ReactComponent };